// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ActivityOverviewChartContainer {\n  padding: 10px !important;\n  height: 100%;\n}\n.screen-large #ActivityOverviewChartContainer {\n  margin: 0 0 0 1vh;\n}\n\n.ao-chart-tooltip .fuel {\n  color: #76adec;\n}\n\n.ao-chart-tooltip .trips {\n  color: #ffb7b7;\n}\n\n.ao-chart-tooltip .revenue {\n  color: #ffc493;\n}", ""]);
// Exports
module.exports = exports;
